<template>
  <el-dialog
    :before-close="handleClose"
    title="查看示例"
    :visible.sync="dialogVisible"
    :width="Number(width + 30) + 'px'"
  >
    <div class="imgBox" :style="{ width: width + 'px' }">
      <img :src="url" />
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      url: {
        type: String,
        default: '',
      },
      width: {
        type: Number,
        default: 750,
      },
    },
    data() {
      return {
        dialogVisible: true,
      }
    },
    methods: {
      handleClose() {
        this.$emit('getSeeExample')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .imgBox {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
    }
  }
</style>
